import { apiRequest } from '@common/api/utils';

async function markLinkedinBtnClick() {
  return apiRequest('POST',
    '/invite-friends/track-post',
    {
      activity_name: 'mentee_shared_half_yearly_stats_on_linkedin',
    });
}

export default {
  markLinkedinBtnClick,
};
